export default __webpack_public_path__ + "static/media/oscer-pres-chest-pain.1d193d4f.svg";